'use strict';

var util = require('../../../util/property-util');
var simUtil = require('../../../util/sim-util');
var arrayUtil = require('../../../util/array-util');
var messageDiscriptors = require('../../../util/messageDiscriptors');
var zabbixUtil = require('../alarm/zabbix-util');

module.exports = /*@ngInject*/ ["$rootScope", "$scope", "$stateParams", "ProjectService", "SimResource", "ConfigurationResourceService", "$filter", "$q", "SimOverviewFactory", "$timeout", "TimeZoneFactory", "NgTableParams", "ConfigurationStoreService", function SimMonitoringPageController($rootScope, $scope, $stateParams, ProjectService, SimResource, ConfigurationResourceService, $filter, $q, SimOverviewFactory, $timeout, TimeZoneFactory, NgTableParams, ConfigurationStoreService) {
    var vm = this;
    vm.chart = SimOverviewFactory.getSimOverviewChart();
    var name = "sim";
    var trainId = $stateParams.trainId;
    var threshold;

    vm.boxes = [
        {boxId: "ALL"}
    ];
    vm.box = vm.boxes[0];
    vm.details = false;

    var sims = [];

    vm.filteredSims = [];
    vm.sim = undefined;
    var configPromise;
    vm.showChart = false;

    vm.simsWithUsageAlerts = [];

    $rootScope.$on('project-config-updated', init);

    init();

    /*
     FUNCTIONS
     */

    function init() {
        $scope.$emit('init-child', name);
        var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( ProjectService.getSelectedProjectId());
        threshold = projectConfiguration && projectConfiguration["simUsageAlertConfiguration"];

        var projectId = ProjectService.getSelectedProjectId();
        if (projectId) {
            getSimsWithUsageAlerts(projectId).then(function(data) {
                vm.simsWithUsageAlerts = data;
                vm.tableParamsSims.reload();
            });
        }

    }

    vm.getClass = function (priority) {
        return simUtil.getSimClass(priority);
    };

    vm.boxChange = function (boxValue) {
        if (boxValue.boxId === "ALL") {
            vm.filteredSims = sims;
            var newFilter = {};
            vm.tableParamsSims.filter(newFilter);
            vm.tableParamsSims.reload();
        } else {
            vm.modem = boxValue.modems[0];
            vm.modemChange(vm.modem);
        }

    };

    vm.modemChange = function (modemValue) {
        var newFilter = {};
        if (modemValue.modem === "ALL" && vm.box.boxId !== "ALL") {
            vm.filteredSims = arrayUtil.filterArray(sims, 'boxId', vm.box.boxId);
            newFilter['boxId'] = vm.box.boxId;
            vm.tableParamsSims.filter(newFilter);
        } else {
            var boxSims = arrayUtil.filterArray(sims, 'boxId', vm.box.boxId);
            vm.filteredSims = arrayUtil.filterArray(boxSims, 'link', modemValue.link);
            newFilter['boxId'] = vm.box.boxId;
            newFilter['link'] = modemValue.link;
            vm.tableParamsSims.filter(newFilter);
        }
        vm.tableParamsSims.reload();
    };

    vm.getColor = function (level) {
        return zabbixUtil.getPriorityColor(level);
    };

    $scope.$on('activate-' + name, function () {
        vm.details = false;
        configPromise && configPromise.then(function () {
            var projectId = ProjectService.getSelectedProjectId();
            if (projectId) {
                getSims(projectId);
            }
        });
    });

    $scope.$on('de-activate-' + name, function () {
        sims = [];
        vm.filteredSims = [];
    });

    vm.showDetails = function (sim) {
        vm.showChart = false;
        vm.details = true;
        vm.isCollapsed = false;
        vm.sim = sim;
        fetchSimData(sim).then(function (data) {
            addDataToChart(data, sim.simConfig.limit)
        })
    };

    vm.showTrain = function () {
        vm.details = false;
        vm.sim = undefined;
    };

    function fetchSimData(sim) {
        var deferred = $q.defer();

        var period = TimeZoneFactory.formatUtcToBackendPeriod(sim.simConfig.currentBeginPeriod,sim.simConfig.currentEndPeriod);

        SimResource.simDataPeriod().query({
            'projectId': ProjectService.getSelectedProjectId(),
            'iccid': sim.iccid,
            'from': period.start,
            'to': period.end
        }).$promise.then(function (data) {
            data = data.sort(function (a, b) {
                return a.timestamp - b.timestamp;
            });
            var totalDownload = 0;
            var totalUpload = 0;
            data.forEach(function (entry) {
                totalDownload += entry["totalDown"] / 1000;
                totalUpload += entry["totalUp"] / 1000;
            });
            sim.totalDownload = totalDownload;
            sim.totalUpload = totalUpload;
            deferred.resolve(data);
        }, function () {
            deferred.resolve();
        });
        return deferred.promise;
    }

    function addDataToChart(dataEntries, limit) {
        "use strict";
        for (var i = vm.chart.series.length - 1; i >= 0; i--) {
            vm.chart.series[i].remove(false);
        }
        var dataArray = [];
        var accumulativeArray = [];
        var limitArray = [];
        var accumulativeTotal = 0;
        dataEntries.forEach(function (dataEntry) {
            var total = (dataEntry.totalDown + dataEntry.totalUp) / 1000;
            var obj = [dataEntry.start, total];
            dataArray.push(obj);
            accumulativeTotal += total;
            var accObj = [dataEntry.start, accumulativeTotal];
            accumulativeArray.push(accObj);
            var limitObj = [dataEntry.start, limit];
            limitArray.push(limitObj);
        });

        vm.chart.addSeries({
            name: 'Data usage',
            yAxis: "0",
            data: dataArray,
            color: "green"
        });

        vm.chart.addSeries({
            name: 'Cumulative curve',
            yAxis: "0",
            data: accumulativeArray,
            color: "blue"
        });

        vm.chart.addSeries({
            name: 'Limit',
            yAxis: "0",
            data: limitArray,
            color: "red"
        });

        vm.chart.get("1").update(
            {
                title: {
                    text: null
                }
            }, false
        );

        vm.chart.redraw();

        $timeout(function () {
            vm.chart.reflow();
            vm.showChart = true;
        });

    }

    function getSims(projectId) {
        SimResource.simsForTrain().query({
            'projectId': projectId,
            'trainId': trainId
        }).$promise.then(function (data) {
            sims = data;
            data.forEach(function (sim) {
                var boxId = sim.boxId;
                var modem = sim.link.replace("CELL_", "MODEM ");
                sim.modem = modem.replace("MODEM ", "");
                var link = sim.link;
                sim.simConfig.operator = messageDiscriptors.getOperatorCode(sim.simConfig.operatorCode);
                sim.active = ( new Date().getTime() - sim.lastSeen ) < 150000;

                var boxObject = arrayUtil.getFirstInList(vm.boxes, 'boxId', boxId);
                if (!util.isDefined(boxObject)) {
                    boxObject = {
                        boxId: boxId,
                        modems: [
                            {modem: "ALL"}
                        ]
                    };
                    vm.boxes.push(boxObject);
                }
                var modemObject = arrayUtil.getFirstInList(boxObject.modems, 'link', link);

                if (!util.isDefined(modemObject)) {
                    modemObject = {
                        link: link,
                        modem: modem
                    };
                    boxObject.modems.push(modemObject);
                }

                var period = TimeZoneFactory.formatUtcToBackendPeriod(sim.simConfig.currentBeginPeriod, sim.simConfig.currentEndPeriod);

                SimResource.simUsage().get({
                    'projectId': ProjectService.getSelectedProjectId(),
                    'from': period.start,
                    'to': period.end,
                    'iccid': sim.iccid
                }).$promise.then(function (simUsage) {
                    if (simUsage.hasOwnProperty('iccid') && util.isDefined(simUsage.iccid)) {
                        sim.totalDownload = simUsage.totalDownload / 1000;
                        sim.totalUpload = simUsage.totalUpload / 1000;
                        var total = sim.totalDownload + sim.totalUpload;
                        var used = (total / sim.simConfig.limit) * 100;
                        if (threshold) {
                            if (used < threshold["warningPercentage"]) {
                                sim.level = 1;
                            } else if (used < threshold["critialPercentage"]) {
                                sim.level = 2;
                            } else {
                                sim.level = 3;
                            }
                        }
                    }
                });
            });
            vm.filteredSims = sims;
        });
    }
     //SIM
     function getSimsWithUsageAlerts(projectId) {
        return new Promise(function(resolve, reject) {
            var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( ProjectService.getSelectedProjectId());
            threshold = projectConfiguration && projectConfiguration["simUsageAlertConfiguration"];
            SimResource.simsForTrain().query({
                'projectId': projectId,
                'trainId': trainId
            }).$promise.then(function (data) {
                var promises = data.map(function (sim) {
                    var modem = sim.link.replace("CELL_", "MODEM ");
                    sim.modem = modem.replace("MODEM ", "");
                    sim.simConfig.operator = messageDiscriptors.getOperatorCode(sim.simConfig.operatorCode);
                    var period = TimeZoneFactory.formatUtcToBackendPeriod(sim.simConfig.currentBeginPeriod, sim.simConfig.currentEndPeriod);
                    var promise = SimResource.simUsage().get({
                        'projectId': ProjectService.getSelectedProjectId(),
                        'from': period.start,
                        'to': period.end,
                        'iccid': sim.iccid
                    }).$promise;
                    return promise;
                });
                Promise.all(promises).then(function(results) {
                    var dataWithUsage = data.map(function(sim) {
                        var simUsage = results.find(function(result) {
                            return result.iccid === sim.iccid;
                        });
                        sim.totalDownload = simUsage.totalDownload / 1000;
                        sim.totalUpload = simUsage.totalUpload / 1000;
                        var total = sim.totalDownload + sim.totalUpload;
                        sim.usage = total;
                        var used = (total / sim.simConfig.limit) * 100;
                        if (threshold) {
                            if (used < threshold["warningPercentage"]) {
                                sim.level = 0;
                            } else if (used < threshold["critialPercentage"]) {
                                sim.level = 2;
                            } else {
                                sim.level = 4;
                            }
                        }
                        return sim;
                    });
                    resolve(dataWithUsage);
                });

            });
        });

    }
   
    vm.tableParamsSims = new NgTableParams({
        page: 1,            // show first page
        count: 20,          // count per page
        filter: {},
        sorting: {
            level: "desc"
        }
    }, {
        counts: [],
        total: sims.length, // length of data
        getData: function (params) {
            var filteredData = params.filter() ?
                $filter('filter')( vm.simsWithUsageAlerts, params.filter()) :
                vm.simsWithUsageAlerts;
            var orderedData = params.sorting() ?
                $filter('orderBy')(filteredData, params.orderBy()) :
                filteredData;
            params.total(orderedData.length);
            return orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count());
        }
    });

}];